import { render, staticRenderFns } from "./bracket_roundRobin_table.vue?vue&type=template&id=3cc3578c"
import script from "./bracket_roundRobin_table.vue?vue&type=script&lang=js"
export * from "./bracket_roundRobin_table.vue?vue&type=script&lang=js"
import style0 from "./bracket_roundRobin_table.vue?vue&type=style&index=0&id=3cc3578c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports